import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_528fc6d6 from 'nuxt_plugin_sentryserver_528fc6d6' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_70feab0d from 'nuxt_plugin_sentryclient_70feab0d' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_NuxtSeo_3e610718 from 'nuxt_plugin_NuxtSeo_3e610718' // Source: ./Nuxt-Seo.js (mode: 'all')
import nuxt_plugin_plugin_672e9393 from 'nuxt_plugin_plugin_672e9393' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_recaptcha_1ac80880 from 'nuxt_plugin_recaptcha_1ac80880' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_clipboard_418450b1 from 'nuxt_plugin_clipboard_418450b1' // Source: ./clipboard.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_57029b79 from 'nuxt_plugin_cookieuniversalnuxt_57029b79' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_templatesplugin65ce78ca_169cb27e from 'nuxt_plugin_templatesplugin65ce78ca_169cb27e' // Source: ./templates.plugin.65ce78ca.js (mode: 'client')
import nuxt_plugin_prismic_a141f762 from 'nuxt_plugin_prismic_a141f762' // Source: ./prismic/plugins/prismic.js (mode: 'all')
import nuxt_plugin_prismiccomponents_7affd288 from 'nuxt_plugin_prismiccomponents_7affd288' // Source: ./prismic/plugins/prismic-components.js (mode: 'all')
import nuxt_plugin_axios_0674bdd1 from 'nuxt_plugin_axios_0674bdd1' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_crawlerplugin7f0420ef_63565c74 from 'nuxt_plugin_crawlerplugin7f0420ef_63565c74' // Source: ./crawler.plugin.7f0420ef.js (mode: 'all')
import nuxt_plugin_staticplugin1b59d27d_be4615c8 from 'nuxt_plugin_staticplugin1b59d27d_be4615c8' // Source: ./static.plugin.1b59d27d.js (mode: 'all')
import nuxt_plugin_workbox_83e5faa6 from 'nuxt_plugin_workbox_83e5faa6' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_44f96680 from 'nuxt_plugin_metaplugin_44f96680' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_3baa1b98 from 'nuxt_plugin_iconplugin_3baa1b98' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_asa_caeae00a from 'nuxt_plugin_asa_caeae00a' // Source: ../plugins/asa (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_gapi_926c2f72 from 'nuxt_plugin_gapi_926c2f72' // Source: ../plugins/gapi (mode: 'client')
import nuxt_plugin_vuedebounce_106b52b8 from 'nuxt_plugin_vuedebounce_106b52b8' // Source: ../plugins/vue-debounce (mode: 'client')
import nuxt_plugin_vuehtml2canvas_f92e0078 from 'nuxt_plugin_vuehtml2canvas_f92e0078' // Source: ../plugins/vue-html2canvas (mode: 'client')
import nuxt_plugin_vuegoodshare_69e65047 from 'nuxt_plugin_vuegoodshare_69e65047' // Source: ../plugins/vue-goodshare (mode: 'client')
import nuxt_plugin_mapboxgl_62971a08 from 'nuxt_plugin_mapboxgl_62971a08' // Source: ../plugins/mapboxgl (mode: 'client')
import nuxt_plugin_vuezoomer_25cd4a4a from 'nuxt_plugin_vuezoomer_25cd4a4a' // Source: ../plugins/vue-zoomer (mode: 'client')
import nuxt_plugin_vue2perfectscrollbar_ddf3318e from 'nuxt_plugin_vue2perfectscrollbar_ddf3318e' // Source: ../plugins/vue2-perfect-scrollbar (mode: 'client')
import nuxt_plugin_vuemasonry_2292e2ec from 'nuxt_plugin_vuemasonry_2292e2ec' // Source: ../plugins/vue-masonry (mode: 'client')
import nuxt_plugin_disqus_2744ae75 from 'nuxt_plugin_disqus_2744ae75' // Source: ../plugins/disqus (mode: 'client')
import nuxt_plugin_tiptap_4290e41c from 'nuxt_plugin_tiptap_4290e41c' // Source: ../plugins/tiptap (mode: 'client')
import nuxt_plugin_plugin_45706a4d from 'nuxt_plugin_plugin_45706a4d' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"robots","name":"robots","content":"index, follow"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"theme-color","content":"#ffffff"},{"hid":"charset","charset":"utf-8"},{"hid":"lang","lang":"en"},{"hid":"language","language":"English"},{"hid":"name","key":"name","property":"name","name":"name","content":"100ASA"},{"hid":"author","key":"author","property":"author","name":"author","content":"100ASA Ltd."},{"hid":"description","key":"description","property":"description","name":"description","content":"Get to know 100ASA, a unique photography website. Top-notch curation. Strict vetting process. Global exposure. Print shop."},{"hid":"url","key":"url","property":"url","name":"url","content":"https:\u002F\u002F100asa.com"},{"hid":"og:site_name","key":"og:site_name","property":"og:site_name","name":"og:site_name","content":"100ASA"},{"hid":"og:title","key":"og:title","property":"og:title","name":"og:title","content":"The Best Photography Website & Community"},{"hid":"og:description","key":"og:description","property":"og:description","name":"og:description","content":"Get to know 100ASA, a unique photography website. Top-notch curation. Strict vetting process. Global exposure. Print shop."},{"hid":"og:locale","key":"og:locale","property":"og:locale","name":"og:locale","content":"en"},{"hid":"og:url","key":"og:url","property":"og:url","name":"og:url","content":"https:\u002F\u002F100asa.com"},{"hid":"og:type","key":"og:type","property":"og:type","name":"og:type","content":"website"},{"hid":"fb:app_id","key":"fb:app_id","property":"fb:app_id","name":"fb:app_id","content":"255430338722005"},{"hid":"fb:page_id","key":"fb:page_id","property":"fb:page_id","name":"fb:page_id","content":"254072871967663"},{"hid":"twitter:title","key":"twitter:title","property":"twitter:title","name":"twitter:title","content":"The Best Photography Website & Community"},{"hid":"twitter:description","key":"twitter:description","property":"twitter:description","name":"twitter:description","content":"Get to know 100ASA, a unique photography website. Top-notch curation. Strict vetting process. Global exposure. Print shop."},{"hid":"twitter:card","key":"twitter:card","property":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","key":"twitter:site","property":"twitter:site","name":"twitter:site","content":"@100asaofficial"},{"hid":"twitter:creator","key":"twitter:creator","property":"twitter:creator","name":"twitter:creator","content":"@100asaofficial"},{"hid":"image","key":"image","property":"image","name":"image","content":"https:\u002F\u002F100asa.com\u002Fimages\u002Fogimage.jpg"}],"link":[{"hid":"canonical","rel":"canonical","href":"https:\u002F\u002F100asa.com\u002F"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png?v=GvbAg4xwqL"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png?v=GvbAg4xwqL"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png?v=GvbAg4xwqL"},{"rel":"manifest","href":"\u002Fsite.webmanifest?v=GvbAg4xwqL"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg?v=GvbAg4xwqL","color":"#777777"},{"rel":"shortcut icon","href":"\u002Ffavicon.ico?v=GvbAg4xwqL"},{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Raleway:ital,wght@0,300;0,400;0,700;1,400&display=swap"}],"script":[{"src":"https:\u002F\u002Ftree-nation.com\u002Fjs\u002Ftrack.js"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-KN1CB8SKHZ","async":true},{"src":"\u002Fjs\u002Fanalytics.js"},{"src":"https:\u002F\u002Fjs.stripe.com\u002Fv3\u002F","defer":true,"async":true},{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Raleway:ital,wght@0,300;0,400;0,700;1,400&display=swap\";document.querySelector(\"head\").appendChild(l);})();"}],"style":[],"noscript":[{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Raleway:ital,wght@0,300;0,400;0,700;1,400&display=swap\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]},"title":"The Best Photography Website & Community | 100ASA"},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_528fc6d6 === 'function') {
    await nuxt_plugin_sentryserver_528fc6d6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_70feab0d === 'function') {
    await nuxt_plugin_sentryclient_70feab0d(app.context, inject)
  }

  if (typeof nuxt_plugin_NuxtSeo_3e610718 === 'function') {
    await nuxt_plugin_NuxtSeo_3e610718(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_672e9393 === 'function') {
    await nuxt_plugin_plugin_672e9393(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_1ac80880 === 'function') {
    await nuxt_plugin_recaptcha_1ac80880(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboard_418450b1 === 'function') {
    await nuxt_plugin_clipboard_418450b1(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_57029b79 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_57029b79(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin65ce78ca_169cb27e === 'function') {
    await nuxt_plugin_templatesplugin65ce78ca_169cb27e(app.context, inject)
  }

  if (typeof nuxt_plugin_prismic_a141f762 === 'function') {
    await nuxt_plugin_prismic_a141f762(app.context, inject)
  }

  if (typeof nuxt_plugin_prismiccomponents_7affd288 === 'function') {
    await nuxt_plugin_prismiccomponents_7affd288(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0674bdd1 === 'function') {
    await nuxt_plugin_axios_0674bdd1(app.context, inject)
  }

  if (typeof nuxt_plugin_crawlerplugin7f0420ef_63565c74 === 'function') {
    await nuxt_plugin_crawlerplugin7f0420ef_63565c74(app.context, inject)
  }

  if (typeof nuxt_plugin_staticplugin1b59d27d_be4615c8 === 'function') {
    await nuxt_plugin_staticplugin1b59d27d_be4615c8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_83e5faa6 === 'function') {
    await nuxt_plugin_workbox_83e5faa6(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_44f96680 === 'function') {
    await nuxt_plugin_metaplugin_44f96680(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_3baa1b98 === 'function') {
    await nuxt_plugin_iconplugin_3baa1b98(app.context, inject)
  }

  if (typeof nuxt_plugin_asa_caeae00a === 'function') {
    await nuxt_plugin_asa_caeae00a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gapi_926c2f72 === 'function') {
    await nuxt_plugin_gapi_926c2f72(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedebounce_106b52b8 === 'function') {
    await nuxt_plugin_vuedebounce_106b52b8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuehtml2canvas_f92e0078 === 'function') {
    await nuxt_plugin_vuehtml2canvas_f92e0078(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegoodshare_69e65047 === 'function') {
    await nuxt_plugin_vuegoodshare_69e65047(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mapboxgl_62971a08 === 'function') {
    await nuxt_plugin_mapboxgl_62971a08(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuezoomer_25cd4a4a === 'function') {
    await nuxt_plugin_vuezoomer_25cd4a4a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2perfectscrollbar_ddf3318e === 'function') {
    await nuxt_plugin_vue2perfectscrollbar_ddf3318e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemasonry_2292e2ec === 'function') {
    await nuxt_plugin_vuemasonry_2292e2ec(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_disqus_2744ae75 === 'function') {
    await nuxt_plugin_disqus_2744ae75(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tiptap_4290e41c === 'function') {
    await nuxt_plugin_tiptap_4290e41c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_45706a4d === 'function') {
    await nuxt_plugin_plugin_45706a4d(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
